import React, { useEffect, useState, useContext } from 'react';

import { LayoutContext } from '../../context/layoutContext';

import TitleToOption from '../../pages/common/TitleToOption';
import OnAirComponent from './OnAirComponent';

import { OnAirTable, OnAirShowComponent } from '../../styles/onAirStyles';
import { OnAirMainBody } from '../../styles/homeStyles';
import { textSilce } from '../../constants/index';
import { useHistory } from 'react-router-dom';

import OnAirSkeleton from '../../components/skeleton/OnAirSkeleton';

import Flicking from '@egjs/react-flicking';

import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';

const OnAir = props => {
  const { matchese } = useContext(LayoutContext);
  const history = useHistory();
  const { data, prevShow, nextShow, typeShow } = props;

  const [onAirList, setOnAirList] = useState([]);

  const [showNum, setShowNum] = useState(0);
  const [prevNum, setPrevNum] = useState(0);
  const [nextNum, setNextNum] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data.length > 0) {
      let activeNum;
      data.map((item, idx) => {
        if (item?.live) activeNum = idx;
      });
      setShowNum(activeNum);
      setOnAirList(data);
      setLoading(true);
    }
  }, [data]);

  useEffect(() => {
    setPrevNum(showNum - 1);
    setNextNum(showNum + 1);
  }, [showNum]);

  // web
  const onAirRenderWeb = list => {
    return (
      <Flicking circular={true} defaultIndex={showNum}>
        {list.map((item, idx) => {
          return (
            <div className='flicking-panel' key={`onAir_${idx}`} style={{ display: 'flex', width: '20%', justifyContent: 'flex-start' }}>
              <OnAirComponent data={item} active={item?.live} />
            </div>
          );
        })}
      </Flicking>
    );
  };

  // mobile
  const onAirRenderMobile = () => {
    return <OnAirComponent data={onAirList[showNum]} active={onAirList[showNum]?.live} />;
  };

  const prevBtn = () => {
    setShowNum(prev => prev - 1);
  };

  const nextBtn = () => {
    setShowNum(next => next + 1);
  };

  const goOnairPage = () => {
    if (matchese) {
      history.push(`${process.env.PUBLIC_URL}/onair`);
    }
  };

  return (
    <OnAirMainBody>
      <TitleToOption
        title={'현재 실시간 TV'}
        point={true}
        titleStyle={{ marginBottom: '10px', fontSize: '22px' }}
        optionType={typeShow && 'onair'}
        titleOnclick={goOnairPage}
      />
      {loading ? (
        <>
          {prevShow && (
            <OnAirShowComponent position={'top'}>
              {onAirList[prevNum] ? (
                <>
                  <span onClick={prevBtn}>이전</span>
                  <h1>{`${textSilce(onAirList[prevNum]?.program?.title, 15)} ${
                    onAirList[prevNum]?.episode?.episodeNo && onAirList[prevNum]?.episode?.episodeNo
                  }화`}</h1>
                  <p>{onAirList[prevNum]?.time ? onAirList[prevNum]?.time : ''}</p>
                </>
              ) : (
                <span>이전화가 존재하지않습니다.</span>
              )}
            </OnAirShowComponent>
          )}

          <OnAirTable>{matchese ? onAirRenderMobile() : onAirRenderWeb(onAirList)}</OnAirTable>

          {nextShow && (
            <OnAirShowComponent position={'bottom'}>
              {onAirList[nextNum] ? (
                <>
                  <span onClick={nextBtn}>다음</span>
                  <h1>{`${textSilce(onAirList[nextNum]?.program?.title, 15)} ${
                    onAirList[nextNum]?.episode?.episodeNo && onAirList[nextNum]?.episode?.episodeNo
                  }화`}</h1>
                  <p>{onAirList[nextNum]?.time ? onAirList[nextNum]?.time : ''}</p>
                </>
              ) : (
                <span>다음화가 존재하지않습니다.</span>
              )}
            </OnAirShowComponent>
          )}
        </>
      ) : (
        <OnAirSkeleton />
      )}
    </OnAirMainBody>
  );
};

export default OnAir;
